module.exports = __webpack_public_path__ + "yaopin.de7d0144.png";